function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 *  Product Specifications
 *    Scripts for the Technical Specifications section on the product page.
 *
 *  Version:
 *    1.0.0 - 2020/03/08
 */

import { register, ShopifySection } from './../ShopifySection';

//Selectors
export var CONTAINER_SELECTOR = '[data-product-specs]';
export var SPECS_VIEW_TOGGLE = '[data-product-specs-more]';
export var SPECS_CONTAINER = '[data-product-specs-specs]';
export var SPECS_SELECT = '[data-product-specs-selector]';
export var SPECS_SELECTOR_SELECTED = '[data-product-specs-selector-selected]';
export var SPECS_SELECTOR_OPTIONS = '[data-product-specs-selector-options]';

//Attrs
export var SPECS_SELECTOR_OPTION = 'data-product-specs-selector-option';
export var SPECS_SELECTOR_COMPARE_SPEC = 'data-product-spec-compare';

//Classes
export var CLASS_EXPANDED = 'is-expanded';
export var CLASS_VISIBLE = 'is-visible';
export var ProductSpecs = /*#__PURE__*/function (_ShopifySection) {
  _inherits(ProductSpecs, _ShopifySection);
  var _super = _createSuper(ProductSpecs);
  function ProductSpecs(container) {
    var _this;
    _classCallCheck(this, ProductSpecs);
    _this = _super.call(this, container);
    _this.viewMore = container.find(SPECS_VIEW_TOGGLE);
    _this.specs = container.find(SPECS_CONTAINER);
    _this.selectElement = container.find(SPECS_SELECT);
    _this.selectorOptions = container.find(SPECS_SELECTOR_OPTIONS);
    _this.selectedValue = container.find(SPECS_SELECTOR_SELECTED);
    _this.compareSpecs = container.find("[".concat(SPECS_SELECTOR_COMPARE_SPEC, "]"));
    container.on('click touch', SPECS_VIEW_TOGGLE, function (e) {
      return _this.onViewMoreToggle(e);
    });
    container.on('click touch', SPECS_SELECTOR_SELECTED, function (e) {
      return _this.onSpecsViewOptions(e);
    });
    container.on('click touch', "[".concat(SPECS_SELECTOR_OPTION, "]"), function (e) {
      return _this.onOptionClick(e);
    });

    //Event to hide if clicked outside
    _this.clickOutsideHandler = function (e) {
      return _this.onClickOutside(e);
    };
    $(document).on('click', _this.clickOutsideHandler);
    return _this;
  }
  _createClass(ProductSpecs, [{
    key: "onOptionClick",
    value: function onOptionClick(e) {
      e.preventDefault();
      e.stopPropagation();

      //Find the handle of our newly selected option
      var self = $(e.currentTarget);
      var handle = self.attr(SPECS_SELECTOR_OPTION);

      //Find all of the specs that have this value
      var newSpecs = this.specs.find("[".concat(SPECS_SELECTOR_COMPARE_SPEC, "=\"").concat(handle, "\"]"));
      if (!newSpecs.length) return;

      //Hide all specs currently
      this.compareSpecs.removeClass(CLASS_VISIBLE);
      newSpecs.addClass(CLASS_VISIBLE);
      this.selectedValue.text(handle);
      this.selectorOptions.removeClass(CLASS_EXPANDED);
    }
  }, {
    key: "onSpecsViewOptions",
    value: function onSpecsViewOptions(e) {
      e.preventDefault();
      e.stopPropagation();
      this.selectElement.toggleClass(CLASS_EXPANDED);
      this.selectorOptions.toggleClass(CLASS_EXPANDED);
    }
  }, {
    key: "onViewMoreToggle",
    value: function onViewMoreToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      this.specs.toggleClass(CLASS_EXPANDED);
      this.viewMore.toggleClass(CLASS_EXPANDED);
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(e) {
      if (!this.selectorOptions.hasClass(CLASS_EXPANDED)) return; //Not visible?
      var check = this.selectorOptions.find(e.target);
      if (check.length) return;
      this.selectorOptions.removeClass(CLASS_EXPANDED);
    }
  }]);
  return ProductSpecs;
}(ShopifySection);
register(CONTAINER_SELECTOR, ProductSpecs);